import { useMemo } from 'react'
import { useClaimRecord } from '@hooks/useClaimRecord'
import { useSessionInfo } from '@hooks/useSessionInfo'
import { ServiceStatus, ServiceType } from '../types'
import { getServiceStatus } from '../helpers/getServiceStatus'

type UseServiceStatusReturn = Record<ServiceType, ServiceStatus | undefined>

export const useServiceStatus = (): UseServiceStatusReturn => {
  const { claimRecordId, claimRecord, claimRecordDeleted } = useClaimRecord()
  const { isGuestUser, isAnonymousUser, isAuthenticated, isSessionReady, isActiveDataChecked } = useSessionInfo()

  const validSession = (isAuthenticated || isGuestUser) && isSessionReady

  return useMemo<UseServiceStatusReturn>(() => {
    const getStatus = (isProductQuote?: boolean): ServiceStatus | undefined => {
      if (isAnonymousUser) {
        return 'unavailable'
      }

      if (validSession && isActiveDataChecked) {
        return getServiceStatus(isProductQuote ? 'product-quote' : 'default', {
          claimRecord,
          claimRecordId,
          claimRecordDeleted,
        })
      }
    }

    const serviceStatus = getStatus()
    const productQuoteServiceStatus = getStatus(true)

    return {
      'benefit-plan': serviceStatus,
      'insurance-data': serviceStatus,
      'product-quote': productQuoteServiceStatus,
    }
  }, [isAnonymousUser, validSession, isActiveDataChecked, claimRecordId, claimRecord, claimRecordDeleted])
}
